import { useState } from 'react';
import axios from 'axios';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

export default function ContactPage() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('sending');

    try {
      await axios.post('https://backend.scholarkart.in/api/contact', formData);
      setStatus('sent');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error(error);
      setStatus('error');
    }
  };

  return (
    <>
        <section className="relative py-16 px-6 bg-gradient-to-r from-[#fdfdfd] to-[#eef5f9] overflow-hidden">


      <div className="container mx-auto max-w-6xl">
        {/* Page Heading */}
        <div className="text-center mb-16">
        <h2 className="text-3xl font-bold text-center text-[#264790] mb-12" style={{ textShadow: '2px 2px 6px rgba(0, 0, 0, 0.15)' }}>
          Get in Touch
        </h2>
        </div>

        {/* Grid Layout: Contact Info + Form */}
        <div className="grid md:grid-cols-2 gap-10">
          
          {/* LEFT: Contact Info */}
          <div className="bg-white shadow-md rounded-xl p-8">
            <h2 className="text-xl font-semibold text-[#264790] mb-6">Contact Information</h2>
            <ul className="space-y-6 text-gray-700 text-base">
              <li className="flex items-start gap-4">
                <FaMapMarkerAlt className="text-2xl text-[#ff7a00] mt-1" />
                <span>
                  Sva Learn,<br />
                  KHB Colony, Bengaluru - 560079, Karnataka, India.
                </span>
              </li>
              <li className="flex items-start gap-4">
                <FaEnvelope className="text-2xl text-[#ff7a00] mt-1" />
                <a href="mailto:svalearn360@gmail.com" className="hover:underline">
                  svalearn360@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-4">
                <FaPhoneAlt className="text-2xl text-[#ff7a00] mt-1" />
                <span>+91 9886688939</span>
              </li>
            </ul>
          </div>

          {/* RIGHT: Contact Form */}
          <div className="bg-white shadow-md rounded-xl p-8">
            <h2 className="text-xl font-semibold text-[#264790] mb-6">Send Us a Message</h2>
              <form className="space-y-6" onSubmit={handleSubmit}>
                <div>
                  <label className="block mb-2 font-medium text-sm text-[#264790]">Full Name</label>
                  <input
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff7a00] outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block mb-2 font-medium text-sm text-[#264790]">Email Address</label>
                  <input
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="you@example.com"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff7a00] outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block mb-2 font-medium text-sm text-[#264790]">Your Message</label>
                  <textarea
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Type your message here..."
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff7a00] outline-none resize-none"
                    required
                  />
                </div>

                {status === 'sent' && <p className="text-green-600">✅ Message sent successfully.</p>}
                {status === 'error' && <p className="text-red-600">❌ Failed to send message. Try again.</p>}

                <button
                  type="submit"
                  disabled={status === 'sending'}
                  className="bg-gradient-to-r from-[#264790] to-[#1B3268] text-white px-6 py-3 rounded-md font-medium shadow hover:opacity-90 transition"
                >
                  {status === 'sending' ? 'Sending...' : 'Submit Message'}
                </button>
              </form>
          </div>
        </div>
      </div>
    </section>


</>
    
  );
}
